import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

@Injectable()
export class ReportsActivateGuard implements CanActivate {
    private readonly reportsPermissions = [
        userPermissionsEnum.advancedMonitoring,
        userPermissionsEnum.socialIntelligence
    ];

    constructor(
        private currentUserState: CurrentUserStateService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.getPermissions()
            .pipe(
                filter(x => !!x),
                map(permissions => {
                    return !!permissions.find(p =>  this.reportsPermissions.includes(p));
                })
            );
    }

}
